import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import { Link } from 'react-router-dom';


// import singlepost from './assets/blogimage/blog/post-images/feat-img-2.jpg';
import './images/blogimage/css/animate.css';
import './images/blogimage/css/splitting.css';
import './images/blogimage/css/main-LTR-1.css';
import './images/blogimage/css/all.min.css';
import './images/blogimage/css/blog.css';
import Footer from './footer';
import NavbarComponent from './navbar';

const BlogDetails = () => {

  const [posts, setPosts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [recentPosts, setRecentPosts] = useState([]);
  const [tags, setTags] = useState([]);
  const [searchTerm, setSearchTerm] = useState(''); // ✅ this fixes all 4 errors
  const searchParams = new URLSearchParams(window.location.search);
  const blogId = searchParams.get('blogId');
  const navigate = useNavigate();

 

  //     axios.get(' https://fittex.io/jeevanapi/api/apptoodhublog?blogId='+blogId+'')
  //     .then(response => {

  //       const PostList = response.data?.data?.blogInfo;
  //       if (Array.isArray(PostList)) {
  //         setPosts(PostList);
  //       } else {
  //         setPosts([]);
  //       }

  //     })
  //     .catch(error => {
  //       console.error("Error fetching categories:", error);
  //       setCategories([]);
  //     });



  //     axios.get('https://fittex.io/jeevanapi/api/apptoodhublog?type=c')
  //     .then(response => {
  //       const categoryList = response.data?.data?.blogCategoryInfo;
  //       if (Array.isArray(categoryList)) {
  //         setCategories(categoryList);
  //       } else {
  //         setCategories([]);
  //       }
        
  //       const TagList = response.data?.data?.blogTagInfo;
  //       if (Array.isArray(TagList)) {
  //         setTags(TagList);
  //       } else {
  //         setTags([]);
  //       }
    
    
        
  //       // const PostList = response.data?.data?.blogInfo;
  //       // if (Array.isArray(PostList)) {
  //       //   setPosts(PostList);
  //       // } else {
  //       //   setPosts([]);
  //       // }
    
    
    
  //       const RecentList = response.data?.data?.blogInfo;
  //       if (Array.isArray(RecentList)) {
  //         setRecentPosts(RecentList);
  //       } else {
  //         setRecentPosts([]);
  //       }
    
    
    
  //     })
  //     .catch(error => {
  //       console.error("Error fetching categories:", error);
  //       setCategories([]);
  //     });
    

  // }, []);


  useEffect(() => {
    // Fetch blog details based on blogId
    axios.get(`https://fittex.io/jeevanapi/api/apptoodhublog?blogId=${blogId}`)
      .then(response => {
        const PostList = response.data?.data?.blogInfo;
        if (Array.isArray(PostList)) {
          setPosts(PostList);
        } else {
          setPosts([]);
        }
      })
      .catch(error => {
        console.error("Error fetching blog details:", error);
        setPosts([]);
      });
  
    // Fetch categories, tags, recent posts
    axios.get('https://fittex.io/jeevanapi/api/apptoodhublog?type=c')
      .then(response => {
        const categoryList = response.data?.data?.blogCategoryInfo;
        setCategories(Array.isArray(categoryList) ? categoryList : []);
        
        const TagList = response.data?.data?.blogTagInfo;
        setTags(Array.isArray(TagList) ? TagList : []);
        
        const RecentList = response.data?.data?.blogInfo;
        setRecentPosts(Array.isArray(RecentList) ? RecentList : []);
      })
      .catch(error => {
        console.error("Error fetching sidebar data:", error);
        setCategories([]);
      });
  
  }, [blogId]); // 🔁 Re-run when blogId changes


  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleSearchSubmit = (e) => {
    e.preventDefault();
  
    // Navigate to blog page with search term in query string
    if (searchTerm.trim()) {
      navigate(`/blogpage/${encodeURIComponent(searchTerm.trim())}`);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top
  }, []);


  // const filteredPosts = posts.filter(post =>
  //   (post.blog_Header || '').toLowerCase().includes(searchTerm.toLowerCase()) ||
  //   (post.blog_Description || '').toLowerCase().includes(searchTerm.toLowerCase())
  // );


// Inside component:
// const navigate = useNavigate();

// const handleCategoryClick = (categoryId) => {
//   navigate(`/blog?categoryId=${categoryId}`);
// };


  return (
    <>
      <NavbarComponent/>
      <Helmet>
        <link
          rel="icon"
          href={`${process.env.PUBLIC_URL}/assets/Images/fav-icon/fav-icon.png`}
        />
        <link
          rel="stylesheet"
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@700;800;900&family=Nunito:wght@400;500;600;700;800;900&display=swap"
        />
      </Helmet>

      <section className="blog blog-home mega-section">
        <div className="container">
          <div className="row">
          {posts.length > 0 ? posts.map((post, idx) => (
          <div className="col-12 col-lg-8 post-main-area">
          {/* <!--post heading area--> */}
              <nav aria-label="breadcrumb ">
                <ul class="breadcrumb wow fadeInUp" data-wow-delay="1s">
                <Link to="/blogpage"> <li class="breadcrumb-item"><a class="breadcrumb-link" href="#0"><i class="fas fa-home icon "></i>home / </a></li></Link> 
                  <li class="breadcrumb-item active">Post single</li>
                </ul>
              </nav>

              <h1 class="post-title">{post.blog_Header} </h1>
              <div class="social"> 
                <h6 class="share-title">share this post on:</h6>
                <div class="share-us">
                  <div class="sc-wraper dir-row sc-size-32">
                    <ul class="sc-list">
                      <li class="sc-item" title="Facebook"><a class="sc-link" href="#0"><i class="fab fa-facebook-f sc-icon"></i></a></li>
                      <li class="sc-item" title="youtube"><a class="sc-link" href="#0"><i class="fab fa-youtube sc-icon"></i></a></li>
                      <li class="sc-item" title="instagram"><a class="sc-link" href="#0"><i class="fab fa-instagram sc-icon"></i></a></li>
                      <li class="sc-item" title="twitter"><a class="sc-link" href="#0"><i class="fab fa-twitter sc-icon"></i></a></li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <h1 className="post-title">{posts.blog_Header}</h1> */}

<div className="post-img-wraper post-featured-area">
  <img className="post-img" src={post.blog_Banner} alt={post.blog_Header} />
</div>

<div className="post-info">
  <a className="info post-cat" href="#"><i className="fas fa-list-alt icon"></i>{post.blog_Category}</a>
  <a className="info post-author" href="#"><i className="fas fa-user icon"></i>{post.author}</a>
  <a className="info post-date" href="#"><i className="fas fa-history icon"></i>{post.blog_Date}</a>
  <a className="info post-time" href="#"><i className="fas fa-eye icon"></i>{post.blog_Views}</a>
  {/* <a className="info post-comments-count" href="#"><i className="fas fa-comments icon"></i>{post.blog_Comments}</a> */}
</div>

<div className="post-content">
  <p className="first-litter post-text">{post.description}</p>
</div>


<div style={{ minHeight: '1000px' }}>
  <iframe
    src={post.blog_LinkPage}
    title="Blog HTML"
    width="100%"
    height="1200px"
    style={{ border: 'none', overflow: 'auto' }}
  ></iframe>
</div>

{/* <div>
  <p>{post.blog_Tags}</p>
</div> */}

<br></br>
<br></br>
<br></br>

<div className="tags panel">
  <ul className="sidebar-list tags-list">
    <li className="tags-icon-label tagicn">
    <i className="fas fa-tags icon"/>
    </li>
    {post.blog_Tags?.split(',').map((tag, index) => (
      <li className="tag-item" key={index}>
        <a className="tag-link" href="#">{tag.trim()}</a>
      </li>
    ))}
  </ul>
</div>







</div>
)) : <p>No categories available.</p>}

            <div className="col-12 col-lg-4">
              <div className="blog-sidebar">

                {/* ✅ Search Bar */}
                <div className="search sidebar-box">
                  <form className="search-form" onSubmit={handleSearchSubmit}>
                    <input
                      className="search-input"
                      type="search"
                      placeholder="Search Posts..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                    />
                    <button className="search-btn" type="submit"><i className="fas fa-search icon"></i></button>
                  </form>

                </div>

{/* Categories */}
<div className="cats sidebar-box">
  <h6 className="sidebar-box-title">
    <i className="fas fa-list-alt icon"></i>Categories:
  </h6>
  <ul className="sidebar-list cats-list">
    {categories.length > 0 ? categories.map((cat, idx) => (
      
      <li
  className="cat-item"
  key={idx} 
  style={{ cursor: "pointer" }}
>

<span className="cat-link"><Link className="post-link" to={`/blogpage?categoryId=${cat.blog_CategoryId}`}>{cat.blog_Category}</Link></span>
<span className="cat-count"><Link className="cat-count" to={`/blogpage?categoryId=${cat.blog_CategoryId}`}>{cat.blog_CategoryCnt}</Link></span>
  
</li>
    )) : <li>No categories available.</li>}
  </ul>
</div>

{/* Recent Posts */}
<div className="recent-posts sidebar-box">
  <h6 className="sidebar-box-title">
    <i className="fas fa-history icon"></i>Recent Posts:
  </h6>
  <ul className="sidebar-list r-posts-list">
    {recentPosts.slice(0, 5).map((post, idx) => (
      <li className="r-post-item" key={idx}>
 <Link to={`/blogDetails?blogId=${post.blog_Id}`} className="r-post-link">
      <div className="r-post-img-wraper">
        <img
          className="r-post-img"
          src={post.blog_Banner}
          alt={post.blog_Header}
        />
      </div>
      <div className="content recentcontent">
        <h6 className="r-post-title">{post.blog_Header}</h6>
        <span className="r-post-date">{post.blog_Date}</span>
      </div>
    </Link>
      </li>
    ))}
  </ul>
</div>




{/* Tags */}
<div className="tags sidebar-box">
  <h6 className="sidebar-box-title">
    <i className="fas fa-tags icon"></i>Tags:
  </h6>
  <ul className="sidebar-list tags-list">
    {tags.length > 0 ? tags.map((tag, idx) => (
      <li className="tag-item" key={idx}>
<Link 
  target="_self" 
  className="tag-link" 
  to={`/blogpage?TagName=${encodeURIComponent(tag.blog_Tag)}`}
>
  {tag.blog_Tag}
</Link>
      </li>
    )) : <li>No tags available.</li>}
  </ul>
</div>


                {/* Social Icons */}
                <div className="follow-us sidebar-box">
                  <h6 className="sidebar-box-title"><i className="fas fa-heart icon"></i>Follow Us On:</h6>
                  <div className="sc-wraper dir-row sc-size-32">
                    <ul className="sc-list">
                      <li className="sc-item"><a className="sc-link" href="#"><i className="fab fa-facebook-f sc-icon"></i></a></li>
                      <li className="sc-item"><a className="sc-link" href="#"><i className="fab fa-youtube sc-icon"></i></a></li>
                      <li className="sc-item"><a className="sc-link" href="#"><i className="fab fa-instagram sc-icon"></i></a></li>
                      <li className="sc-item"><a className="sc-link" href="#"><i className="fab fa-twitter sc-icon"></i></a></li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </section>



      {/* Pagination (static for now) */}
      {/* <div class="col-12">
                  <nav class="posts-pagination">
                    <ul class="pagination justify-content-center">
                      <li class="posts-page-item deactive-posts-page-item"><a class="posts-page-link " href="#" title="Previous Post"><i class="fas fa-arrow-left icon "></i></a></li>
                      <li class="posts-page-item active"><a class="posts-page-link " href="#">1</a></li>
                      <li class="posts-page-item"><a class="posts-page-link" href="#">2</a></li>
                      <li class="posts-page-item"><a class="posts-page-link" href="#">3</a></li>
                      <li class="posts-page-item"><a class="posts-page-link" href="#">4</a></li>
                      <li class="posts-page-item"><a class="posts-page-link" href="#">5</a></li>
                      <li class="posts-page-item"><a class="posts-page-link" href="#" title="Next Post"><i class="fas fa-arrow-right icon "></i></a></li>
                    </ul>
                  </nav> 
                  <div> 
                  testing 
                  This is the Hidden Footer Decalre that Her remaining for serach for and pagination need to works. These twos work otherwise all are completed.Rememeber like thise one.</div>
                </div> */}

      <Footer />
    </>
  );
};

export default BlogDetails;